import * as Yup from "yup";
export const validationSchemaGoogleNewsSearchTerm = () => {
  return Yup.object({
    keyword: Yup.string().required("Search term is required."),
    language: Yup.object().required("Language is required.")
  });
};
